import { TranslationKey } from '../functions/i18n';

export const es: Record<TranslationKey, string> = {
  'nav.records': 'Registros',
  'nav.meds': 'Medicamentos',
  'nav.guide': 'Biblioteca',
  'nav.options': 'Recordatorios',
  'topbar.welcome': 'Bienvenido',
  'splash.tagline': 'Master Pet Health. Conquer the Fellowship.',
  'records.tab.todayEntry': 'Diario',
  'records.tab.allCards': 'Historial',
  'records.tab.worksheet': 'Datos',
  'meds.title': 'Medicamentos',
  'meds.empty': 'Aún no hay medicamentos',
  'trends.title': 'Trends',
  'trends.noDataTitle': 'Aún no hay datos',
  'trends.noDataBody': 'Empieza a registrar tus signos vitales en la pestaña Tarjetas para ver tendencias aquí.',
  'trends.moreDataNeeded': 'Se necesitan más datos',
  'trends.moreDataNeededBody': 'Necesitamos al menos 3 días de datos registrados para generar tendencias. ¡Sigue así!',
  'trends.avgWeight': 'Peso promedio',
  'trends.avgHeartRate': 'Avg Heart Rate',
  'trends.avgRespRate': 'Frec. respiratoria prom.',
  'trends.avgMucousMembrane': 'Mucosas promedio',
  'trends.avgWaterIntake': 'Ingesta de agua promedio',
  'trends.avgTemperature': 'Temperatura promedio',
  'trends.weightTrend': 'Weight Trend',
  'trends.heartRateTrend': 'Heart Rate Trend',
  'trends.respRateTrend': 'Respiratory Rate Trend',
  'trends.mucousMembraneTrend': 'Distribución de mucosas',
  'trends.fluidIntakeTrend': 'Water Intake Trend',
  'trends.foodIntakeTrend': 'Tendencia ingesta alimentaria',
  'trends.avgFoodIntake': 'Ingesta alimentaria promedio',
  'trends.day': 'día',
  'trends.days': 'días',
  'trends.tooltipWeight': 'Peso',
  'trends.tooltipFluid': 'Ingesta de líquidos',
  'trends.tooltipFood': 'Ingesta alimentaria',
  'trends.tooltipHeartRate': 'Heart Rate',
  'trends.tooltipRespRate': 'Resp. Rate',
  'trends.tooltipMucousMembrane': 'Mucosas',
  'trends.fluidBalanceTrend': 'Tendencia del balance hídrico',
  'trends.tempTrend': 'Tendencia de temperatura',
  'trends.moodTrend': 'Tendencia del estado de ánimo',
  'trends.mucousMembrane.pink': 'Rosas',
  'trends.mucousMembrane.red': 'Rojas',
  'trends.mucousMembrane.blue': 'Azules',
  'trends.mucousMembrane.white': 'Blancas',
  'trends.noMucousMembraneData': 'Todavía no hay registros de mucosas en este rango de tiempo.',
  'trends.tooltipFluidBalance': 'Balance hídrico (Entrada − Salida)',
  'trends.moodLabel.terrible': 'Terrible',
  'trends.moodLabel.notGreat': 'No muy bien',
  'trends.moodLabel.okay': 'Regular',
  'trends.moodLabel.good': 'Bien',
  'trends.moodLabel.great': 'Genial',
  'trends.tooltipTemp': 'Temperatura',
  'trends.tooltipMood': 'Estado de ánimo',
  'trends.customise': 'Personalizar',
  'trends.resetLayout': 'Restablecer diseño',
  'trends.viewPlans': 'Ver planes',
  'trends.trendsLockedTitle': 'Las tendencias son una función de pago',
  'trends.trendsLockedBody': 'Suscríbete a KodaCare para hacer seguimiento de tu peso, presión arterial, ingesta de líquidos y más con el tiempo.',
  'trends.lifetimeLockedTitle': 'Función Lifetime',
  'trends.lifetimeLockedBody': 'Actualiza al plan Lifetime para desbloquear tendencias de frecuencia respiratoria, mucosas y temperatura, más un diseño de gráficos totalmente personalizable.',
  'guide.digestLockedTitle': 'Digest Mensual Renal',
  'guide.digestLockedBody': 'Actualiza al plan Lifetime para recibir nuestro boletín mensual curado — las noticias más relevantes en tecnología renal, investigación farmacológica e historias de la comunidad trasplantada.',
  'options.title': 'Notificaciones',
  'options.appPreferences': 'Preferencias de la app',
  'options.language': 'Idioma',
  'options.units': 'Unidades',
  'options.metric': 'Métrico',
  'options.imperial': 'Imperial',
  'options.dateFormat': 'Formato de fecha',
  'options.timeFormat': 'Formato de hora',
  'options.transplant': 'Trasplante',
  'options.editProfile': 'Editar perfil',
  'options.saveToHomeScreen': 'Instalar aplicación',
  'options.logOut': 'Cerrar sesión',
  'options.fullName': 'Nombre completo',
  'options.profession': 'Profesión',
  'options.professionPlaceholder': 'ej. Enfermero, Cirujano',
  'options.emailAddress': 'Correo electrónico',
  'options.emailCannotChange': 'El correo no se puede cambiar.',
  'options.transplantDate': 'Fecha del trasplante',
  'options.changePassword': 'Cambiar contraseña',
  'options.deleteAccount': 'Eliminar cuenta',
  'options.cancel': 'Cancelar',
  'options.saveChanges': 'Guardar cambios',
  'login.email': 'Correo',
  'login.password': 'Contraseña',
  'login.forgotPassword': '¿Olvidaste tu contraseña?',
  'login.signIn': 'Iniciar sesión',
  'login.continueWithGoogle': 'Continuar con Google',
  'login.noAccount': '¿No tienes una cuenta?',
  'login.register': 'Registrarse',
  'login.or': 'o',
  'login.rememberMe': 'Recordarme durante 30 días',
  'forgot.title': 'Restablece tu contraseña',
  'forgot.subtitle': 'Introduce tu correo y te enviaremos un enlace para restablecer tu contraseña.',
  'forgot.checkInboxTitle': 'Revisa tu bandeja de entrada',
  'forgot.checkInboxBody': 'Enviamos un enlace de restablecimiento de contraseña a {email}. Sigue el enlace para elegir una nueva contraseña.',
  'forgot.spamHint': '¿No lo recibiste? Revisa tu carpeta de spam o correo no deseado.',
  'forgot.backToSignIn': 'Volver a iniciar sesión',
  'forgot.sendResetLink': 'Enviar enlace de restablecimiento',
  'forgot.rememberPassword': '¿Recuerdas tu contraseña?',
  'forgot.legal': 'Al iniciar sesión, aceptas nuestros Términos del servicio y Política de privacidad.',
  'forgot.errorNoAccount': 'No se encontró una cuenta con esa dirección de correo.',
  'forgot.errorNetwork': 'Error de red. Revisa tu conexión e inténtalo de nuevo.',
  'forgot.errorGeneric': 'No se pudo enviar el correo de restablecimiento. Inténtalo de nuevo.',
  'verify.title': 'Verifica tu correo electrónico',
  'verify.subtitle': 'Enviamos un enlace de verificación a {email}. Haz clic en el enlace de ese correo y luego vuelve e inicia sesión.',
  'verify.errorResend': 'No se pudo reenviar el correo. Inténtalo de nuevo en un momento.',
  'verify.resent': 'Correo de verificación reenviado — revisa tu bandeja de entrada.',
  'verify.emailSent': 'Correo enviado ✓',
  'verify.resend': 'Reenviar correo de verificación',
  'verify.backToSignIn': 'Volver a iniciar sesión',
  'verify.spamHint': '¿No lo recibiste? Revisa tu carpeta de spam o correo no deseado.',
  'authAction.loading': 'Validando tu enlace…',
  'authAction.error.missingInfo': 'A este enlace de confirmación le falta información obligatoria.',
  'authAction.error.unsupportedMode': 'Este tipo de acción aún no está soportado en esta página.',
  'authAction.error.expired': 'Este enlace ha caducado. Solicita uno nuevo.',
  'authAction.error.invalid': 'Este enlace no es válido o ya fue utilizado.',
  'authAction.error.userDisabled': 'Esta cuenta está deshabilitada.',
  'authAction.error.userNotFound': 'No se encontró ninguna cuenta para este enlace.',
  'authAction.error.weakPassword': 'Tu nueva contraseña es demasiado débil. Elige una más segura.',
  'authAction.error.generic': 'No pudimos procesar este enlace. Solicita uno nuevo e inténtalo de nuevo.',
  'authAction.error.resetInvalid': 'Este enlace de restablecimiento no es válido. Solicita uno nuevo.',
  'authAction.error.passwordMin': 'La contraseña debe tener al menos 8 caracteres.',
  'authAction.error.passwordMismatch': 'Las contraseñas no coinciden.',
  'authAction.verifySuccessTitle': 'Correo confirmado',
  'authAction.verifySuccessBody': 'Tu correo ya está verificado. Puedes iniciar sesión para continuar.',
  'authAction.recoverSuccessTitle': 'Correo restaurado',
  'authAction.recoverSuccessBody': 'El cambio de correo se revirtió correctamente. Vuelve a iniciar sesión.',
  'authAction.continue': 'Continuar',
  'authAction.goToSignIn': 'Ir a iniciar sesión',
  'authAction.resetTitle': 'Establecer nueva contraseña',
  'authAction.resetBody': 'Restableciendo contraseña para {email}',
  'authAction.newPassword': 'Nueva contraseña',
  'authAction.confirmNewPassword': 'Confirmar nueva contraseña',
  'authAction.updatePassword': 'Actualizar contraseña',
  'authAction.resetSuccessTitle': 'Contraseña actualizada',
  'authAction.resetSuccessBody': 'Tu contraseña se restableció correctamente.',
  'authAction.signIn': 'Iniciar sesión',
  'authAction.linkUnavailableTitle': 'Enlace no disponible',
  'authAction.requestNewResetLink': 'Solicitar un nuevo enlace de restablecimiento',
  'authAction.backToSignIn': 'Volver a iniciar sesión',
  'register.title': 'Crea tu cuenta',
  'register.fullName': 'Nombre completo',
  'register.operationDate': 'Fecha de trasplante / operación',
  'register.email': 'Correo',
  'register.password': 'Contraseña',
  'register.confirmPassword': 'Confirmar contraseña',
  'register.createAccount': 'Crear cuenta',
  'register.haveAccount': '¿Ya tienes una cuenta?',
  'register.signIn': 'Iniciar sesión',
  'guide.comingSoon': 'Próximamente',
  'guide.motivation': '¡Tú puedes! Volverás más fuerte que nunca.',
  // Records page
  'records.todaysOverview': 'Resumen de hoy',
  'records.selectedDayOverview': 'Resumen del día seleccionado',
  'records.weight': 'Peso',
  'records.fluids': 'Ingesta',
  'records.fluidIntake': 'Ingesta de líquidos',
  'records.foodIntake': 'Ingesta de alimentos',
  'records.urineOutput': 'Producción de orina',
  'records.saveWeight': 'Guardar peso',
  'records.undoWeight': 'Deshacer peso',
  'records.weightRecorded': 'Peso registrado',
  'records.weightRecordedToday': 'Peso registrado hoy',
  'records.add': 'Añadir',
  'records.total': 'total',
  'records.morningVitals': 'Signos vitales de la mañana',
  'records.afternoonVitals': 'Signos vitales de la tarde',
  'records.morningVitalsRecorded': 'Signos vitales de la mañana registrados',
  'records.afternoonVitalsRecorded': 'Signos vitales de la tarde registrados',
  'records.saveVitals': 'Guardar signos vitales',
  'records.resetTodaysData': 'Restablecer datos de hoy',
  'records.resetConfirmMessage': 'Se eliminarán todos los datos de hoy. Esto no se puede deshacer.',
  'records.dailyLimitReached': 'Límite diario alcanzado (9999ml)',
  'records.newEntry': 'Nueva entrada',
  'records.addNewEntry': 'Añadir nueva entrada',
  'records.saveEntry': 'Guardar entrada',
  'records.cancel': 'Cancelar',
  'records.date': 'Fecha',
  'records.morning': 'Mañana',
  'records.afternoon': 'Tarde',
  'records.daily': 'Diario',
  'records.bpSystolic': 'PA sistólica',
  'records.bpDiastolic': 'PA diastólica',
  'records.pulse': 'Pulso',
  'records.temp': 'Temp.',
  'records.downloadCsvFor': 'Descargar CSV para:',
  'records.thisWeek': 'Esta semana',
  'records.thisMonth': 'Este mes',
  'records.thisYear': 'Este año',
  'records.shareDataTitle': 'Compartir datos con el médico',
  'records.dataCopiedToClipboard': 'Datos copiados al portapapeles. Ahora puede pegarlos en un correo o mensaje.',
  'records.noLogEntriesYet': 'Aún no hay entradas',
  'records.fillAtLeastOneField': 'Por favor complete al menos un campo',
  'records.fluid': 'Líquido',
  'records.amBp': 'PA mañana',
  'records.amPulse': 'Pulso mañana',
  'records.amTemp': 'Temp. mañana',
  'records.pmBp': 'PA tarde',
  'records.pmPulse': 'Pulso tarde',
  'records.pmTemp': 'Temp. tarde',
  'records.vitals': 'Signos vitales',
  'records.vitalsTime': 'Vitales:',
  'records.filterBy': 'Filtrar por',
  'records.week': 'Semana',
  'records.month': 'Mes',
  'records.year': 'Año',
  'records.entry': 'entrada',
  'records.entries': 'entradas',
  'records.today': 'Hoy',
  'records.fluidIn': 'Líquido entrada',
  'records.deleteLogEntry': '¿Eliminar esta entrada?',
  'records.undoWeightEntry': 'Deshacer entrada de peso',
  'records.undoLastFluidEntry': 'Deshacer última entrada de líquido',
  'records.undoLastUrineEntry': 'Deshacer última entrada de orina',
  'records.toolbar.addNote': '+ Añadir nota',
  'records.toolbar.editNote': 'Editar nota',
  'records.toolbar.intake': 'Ingesta',
  'records.toolbar.saveNote': 'Guardar nota',
  'records.toolbar.updateNote': 'Actualizar nota',  'records.toolbar.notesPlaceholder': 'Qué anotar — tos o estornudos, estrés por eventos cotidianos.\no\nCambios en — secreciones, sueño, apetito, consumo de agua.',
  'records.toolbar.add': 'Añadir',
  'records.toolbar.save': 'Guardar',
  'records.undoMorningVitals': 'Deshacer vitales de la mañana',
  'records.undoAfternoonVitals': 'Deshacer vitales de la tarde',
  'records.amount': 'Cantidad',
  'records.tab.documents': 'Bóveda',
  'records.documentsTitle': 'Bóveda de documentos',
  'records.documentsSubtitle': 'Guarda análisis, escáneres e informes en un lugar seguro.',
  'records.searchDocuments': 'Buscar documentos…',
  'records.uploadDocument': 'Subir archivo',
  'records.takePhoto': 'Tomar foto',
  'records.maxFilesReached': 'Se alcanzó el límite de archivos para esta cuenta.',
  'records.categoryAll': 'Todos',
  'records.bucketLabs': 'Análisis',
  'records.bucketScans': 'Escáneres',
  'records.bucketLetters': 'Cartas del nefrólogo',
  'records.bucketDischarge': 'Papeles de alta',
  'records.bucketPrescriptions': 'Recetas',
  'records.bucketOther': 'Otros',
  'records.noDocumentsYet': 'Aún no hay documentos',
  'records.titleOptional': 'Título (opcional)',
  'records.noteOptional': 'Nota (opcional)',
  'records.documentDate': 'Fecha del documento',
  'records.uploading': 'Subiendo…',
  'records.openFile': 'Abrir',
  'records.deleteFile': 'Eliminar',
  'records.deleteFileConfirm': '¿Eliminar este archivo de la bóveda?',
  'records.dateAlreadyHasEntry': 'Esta fecha ya tiene una entrada. Use el botón editar en la tabla.',
  'records.deleteEntry': 'Eliminar entrada',
  'records.deleteEntryConfirm': '¿Está seguro de que desea eliminar todos los datos de esta fecha?',
  'records.editEntry': 'Editar entrada',
  'records.observations': 'Observaciones',
  'records.howAreYouFeeling': '¿Cómo te sientes hoy?',
  'records.observationsPlaceholder': 'Qué anotar — tos o estornudos, estrés por eventos cotidianos.\no\nCambios en — secreciones, sueño, apetito, consumo de agua.',
  'records.saveObservations': 'Guardar observaciones',
  'records.observationsRecorded': 'Observaciones guardadas',
  'records.undoObservations': 'Deshacer observaciones',
  'records.moodTerribleLabel': 'Terrible',
  'records.moodBadLabel': 'No muy bien',
  'records.moodOkayLabel': 'Regular',
  'records.moodGoodLabel': 'Bien',
  'records.moodGreatLabel': 'Muy bien',
  'records.noObservations': 'Sin observaciones',
  'records.mood': 'Estado de ánimo',
  // Notification Center
  'notifications.title': 'Todos los recordatorios',
  'notifications.allReminders': 'Todos los recordatorios',
  'notifications.storageNote': 'Se muestran los últimos 5 días de recordatorios.',
  'notifications.new': 'nuevo',
  'notifications.markAllRead': 'Marcar todo como leído',
  'notifications.allCaughtUp': '¡Todo al día!',
  'notifications.clearAll': 'Borrar todo',
  'notifications.clearAllConfirm': 'Toca de nuevo para borrar todo',
  // Delete Confirm Modal
  'deleteConfirm.defaultTitle': '¿Eliminar este elemento?',
  'deleteConfirm.cancel': 'Cancelar',
  'deleteConfirm.delete': 'Eliminar',
  'deleteConfirm.dontShowAgain': 'No mostrar de nuevo',
  // Settings Panel
  'settings.title': 'Configuración',
  'settings.preferences': 'Preferencias',
  'settings.language': 'Idioma',
  'settings.units': 'Unidades',
  'settings.metric': 'Métrico',
  'settings.imperial': 'Imperial',
  'settings.dateFormat': 'Formato de fecha',
  'settings.timeFormat': 'Formato de hora',
  'settings.logOut': 'Cerrar sesión',
  'settings.editProfile': 'Editar perfil',
  'settings.fullName': 'Nombre completo',
  'settings.profession': 'Profesión',
  'settings.professionPlaceholder': 'ej. Enfermero, Cirujano',
  'settings.emailAddress': 'Correo electrónico',
  'settings.emailCannotChange': 'El correo no se puede cambiar.',
  'settings.transplantDate': 'Fecha del trasplante',
  'settings.changePassword': 'Cambiar contraseña',
  'settings.deleteAccount': 'Eliminar cuenta',
  'settings.deleteAccountConfirm': '¿Está seguro de que desea eliminar su cuenta? Esta acción no se puede deshacer.',
  'deleteAccount.title': '¿Eliminar su cuenta?',
  'deleteAccount.bullet1': 'Se cerrará sesión inmediatamente y no podrá volver a iniciarla.',
  'deleteAccount.bullet2': 'Sus registros de salud, medicamentos y todos sus datos personales serán eliminados permanentemente en un plazo de 30 días.',
  'deleteAccount.bullet3': 'Las suscripciones activas no se cancelarán automáticamente; cancélelas por separado en Configuración.',
  'deleteAccount.footer': 'Esta acción no se puede deshacer.',
  'deleteAccount.confirm': 'Sí, eliminar mi cuenta',
  'deleteAccount.cancel': 'Conservar mi cuenta',
  'settings.cancel': 'Cancelar',
  'settings.saveChanges': 'Guardar cambios',
  // Meds page
  'meds.removeMedication': 'Eliminar medicamento',
  'meds.removeConfirm': '¿Está seguro de que desea eliminar este medicamento?',
  'meds.medCount': 'med.',
  'meds.medsCount': 'meds.',
  'meds.remindersEnabled': 'Recordatorios activados',
  'meds.remindersDisabled': 'Recordatorios desactivados',
  'meds.addMedication': 'Agregar medicamento',
  'meds.cancel': 'Cancelar',
  'meds.medicationName': 'Nombre del medicamento',
  'meds.medicationNamePlaceholder': 'ej. Tacrolimus',
  'meds.dosage': 'Dosis',
  'meds.dosagePlaceholder': 'ej. 1',
  'meds.timeslots': 'Horarios',
  'meds.addTime': '+ Agregar hora',
  'meds.type': 'Tipo',
  'meds.shapeCapsule': 'Cápsula',
  'meds.shapeOval': 'Ovalada',
  'meds.shapeTwoPart': 'Dos partes',
  'meds.shapeDiamond': 'Diamante',
  'meds.shapeRound': 'Redonda',
  'meds.shapeFlat': 'Plana',
  'meds.shapeTriangle': 'Triángulo',
  'meds.pillColour': 'Color de la píldora',
  'meds.customColour': 'Color personalizado',
  'meds.fillAllFields': 'Por favor complete todos los campos incluyendo al menos un horario',
  'meds.edit': 'Editar',
  'meds.delete': 'Eliminar',
  'meds.duplicate': 'Duplicar',
  'meds.dropHere': 'Soltar aquí para mover',
  'meds.editMedication': 'Editar medicamento',
  'meds.saveChanges': 'Guardar cambios',
  'contacts.edit': 'Editar',
  'contacts.delete': 'Eliminar',
  'contacts.editContact': 'Editar contacto',
  'contacts.addContact': 'Añadir contacto',
  'contacts.cancel': 'Cancelar',
  'contacts.saveChanges': 'Guardar cambios',
  'contacts.saveContact': 'Guardar contacto',
  'contacts.name': 'Nombre',
  'contacts.phoneNumber': 'Teléfono',
  'contacts.email': 'Correo electrónico',
  'contacts.nephrologist': 'Nefrólogo',
  'contacts.pharmacy': 'Farmacia',
  'contacts.emergency': 'Emergencia',
  'contacts.other': 'Otro',
  'contacts.nameRequired': 'El nombre es obligatorio',
  'contacts.phoneRequired': 'El teléfono es obligatorio',
  'contacts.deleteContact': 'Eliminar contacto',
  'contacts.deleteContactMsg': '¿Eliminar este contacto de tu equipo de cuidados?',
  'contacts.addNewContact': 'Añadir nuevo contacto',
  'contacts.noContacts': 'Aún no hay contactos',
  'contacts.addCareTeam': 'Pulsa el botón de arriba para añadir tu equipo',
  'contacts.sortRecent': 'Más reciente',
  'contacts.sortAlpha': 'Alfabético',
  'records.shareCard': 'Compartir ficha',
  'records.undoObservation': 'Deshacer observación',
  // Notification settings
  'options.notifications': 'Notificaciones',
  'options.notificationsAll': 'Todas',
  'options.notificationsLogs': 'Registros',
  'options.notificationsMeds': 'Medicamentos',
  'options.notificationsNone': 'Ninguna',
  'options.subscription': 'Suscripción',
  'options.subscriptionSubtitle': 'Cronograma de cobro y detalles de renovación.',
  'options.subscriptionPlan': 'Plan',
  'options.subscriptionStatus': 'Estado',
  'options.subscriptionStarted': 'Iniciada',
  'options.subscriptionNextPayment': 'Próximo pago',
  'options.subscriptionExpires': 'Vence',
  'options.subscriptionNoActive': 'No hay suscripción activa',
  'options.subscriptionUnavailable': 'No disponible',
  'account.title': 'Configuración de la cuenta',
  'account.subtitle': 'Revisa tu perfil y administra tus opciones de suscripción.',
  'account.profile': 'Perfil',
  'account.profileSubtitle': 'Tu nombre, detalles de tu mascota y tarjeta médica',
  'account.profileSaved': 'Perfil guardado.',
  'account.profileSaveError': 'No se pudo guardar el perfil. Inténtalo de nuevo.',
  'account.savingProfile': 'Guardando…',
  'account.saveProfile': 'Guardar perfil',
  'account.openDashboard': 'Abrir panel',
  'account.starterTrial': 'Starter (Prueba)',
  'account.expired': 'Vencida',
  'account.loading': 'Cargando…',
  'account.trialDaysLeft': 'Prueba — quedan {days} día{s}',
  'account.expiredDaysLeft': 'Vencida — {days} día{s} para re-suscribirte',
  'account.currentPlan': 'Plan actual',
  'account.fetchingBilling': 'Obteniendo los últimos detalles de facturación.',
  'account.manageSubscription': 'Administrar suscripción',
  'account.security': 'Cuenta y seguridad',
  'account.memberSince': 'Miembro desde',
  'account.lastLogin': 'Último acceso',
  'account.passwordResetSent': 'Correo de restablecimiento enviado — revisa tu bandeja de entrada.',
  'account.resetPassword': 'Restablecer contraseña',
  'account.resetPasswordEmailError': 'No se pudo enviar el correo de restablecimiento. Inténtalo de nuevo.',
  'account.deleteRequiresRecentLogin': 'Por seguridad, cierra sesión y vuelve a iniciar sesión antes de eliminar tu cuenta.',
  'account.deleteFailed': 'No se pudo eliminar la cuenta. Inténtalo de nuevo.',
  'account.deleting': 'Eliminando…',
  'account.dataPrivacy': 'Datos y privacidad',
  'account.exportDescription': 'Puedes exportar todos los datos vinculados a tu cuenta como archivo CSV.',
  'account.preparingExport': 'Preparando exportación…',
  'account.downloadAllData': 'Descargar todos mis datos',
  'options.notificationSettings': 'Recordatorios',
  'options.remindersSubtitle': 'Alertas de medicamentos y notificaciones push',
  'options.permissions': 'Permisos:',
  'options.activate': 'Activar:',
  'options.logReminderTimes': 'Horarios de recordatorio de registros:',
  'options.logReminderTime': 'Hora de recordatorio:',
  'options.permissionGrant': 'Conceder permiso',
  'options.browserBlockedHelp': 'Las notificaciones están bloqueadas por tu navegador. Para activarlas, haz clic en el icono de candado/información en la barra de direcciones y permite notificaciones para este sitio.',
  'options.appOn': 'App: Activada',
  'options.appOff': 'App: Desactivada',
  'options.browserAllowed': 'Navegador: Permitido',
  'options.browserUnsupported': 'Navegador: No compatible',
  'options.browserBlocked': 'Navegador: Bloqueado',
  'options.browserNotAsked': 'Navegador: Sin solicitar',
  'options.activityTitle': 'Actividad',
  // Lab Glossary
  'guide.labGlossary.intro': 'Comprenda los marcadores de laboratorio comunes en el seguimiento post-trasplante. Esta información es educativa — siempre discuta sus resultados con su equipo de trasplante.',
  'guide.labGlossary.search': 'Buscar marcadores…',
  'guide.labGlossary.all': 'Todos',
  'guide.labGlossary.noMarkersFound': 'No se encontraron marcadores.',
  'guide.labGlossary.referenceRange': 'Rango de referencia típico',
  'guide.labGlossary.note': '⚠️ Nota',
  'guide.labGlossary.marker.creatinine.name': 'Creatinine',
  'guide.labGlossary.marker.creatinine.abbr': 'CREA',
  'guide.labGlossary.marker.creatinine.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.creatinine.why': 'A core kidney marker in dogs and cats. Higher values can suggest reduced kidney filtration, but can also rise with dehydration.',
  'guide.labGlossary.marker.creatinine.typical': 'Dog: ~0.5–1.8 mg/dL · Cat: ~0.8–2.4 mg/dL (lab dependent).',
  'guide.labGlossary.marker.creatinine.note': 'Always interpret with SDMA, BUN, urine concentration, and hydration status.',
  'guide.labGlossary.marker.egfr.name': 'SDMA',
  'guide.labGlossary.marker.egfr.abbr': 'SDMA',
  'guide.labGlossary.marker.egfr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.egfr.why': 'Symmetric dimethylarginine can rise earlier than creatinine and helps detect early kidney changes.',
  'guide.labGlossary.marker.egfr.typical': 'Usually <14 µg/dL in many pet labs.',
  'guide.labGlossary.marker.egfr.note': 'Persistent increases are more meaningful than a one-off value.',
  'guide.labGlossary.marker.bun.name': 'Blood Urea Nitrogen',
  'guide.labGlossary.marker.bun.abbr': 'BUN / Urea',
  'guide.labGlossary.marker.bun.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.bun.why': 'BUN reflects protein waste handling. It can rise with kidney disease, dehydration, GI bleeding, or high-protein diets.',
  'guide.labGlossary.marker.bun.typical': 'Dog: ~7–27 mg/dL · Cat: ~16–36 mg/dL (lab dependent).',
  'guide.labGlossary.marker.tacrolimus.name': 'ALP (Alkaline Phosphatase)',
  'guide.labGlossary.marker.tacrolimus.abbr': 'ALP',
  'guide.labGlossary.marker.tacrolimus.category': 'Liver',
  'guide.labGlossary.marker.tacrolimus.why': 'ALP can increase with liver or bile duct disease, steroid exposure, and growth in young pets.',
  'guide.labGlossary.marker.tacrolimus.typical': 'Often ~20–150 U/L in adult dogs/cats (method dependent).',
  'guide.labGlossary.marker.tacrolimus.note': 'Mild isolated rises can be non-specific; trend and context matter.',
  'guide.labGlossary.marker.ciclosporin.name': 'GGT (Gamma-Glutamyl Transferase)',
  'guide.labGlossary.marker.ciclosporin.abbr': 'GGT',
  'guide.labGlossary.marker.ciclosporin.category': 'Liver',
  'guide.labGlossary.marker.ciclosporin.why': 'GGT helps assess bile flow and hepatobiliary disease, often interpreted alongside ALP and bilirubin.',
  'guide.labGlossary.marker.ciclosporin.typical': 'Often low in healthy pets; reference limits vary by lab.',
  'guide.labGlossary.marker.mmf.name': 'Total Protein',
  'guide.labGlossary.marker.mmf.abbr': 'TP',
  'guide.labGlossary.marker.mmf.category': 'Proteins & Other',
  'guide.labGlossary.marker.mmf.why': 'Total protein combines albumin and globulins and can reflect hydration, inflammation, or protein loss.',
  'guide.labGlossary.marker.mmf.typical': 'Dog: ~5.5–7.5 g/dL · Cat: ~6.0–8.0 g/dL.',
  'guide.labGlossary.marker.potassium.name': 'Potassium',
  'guide.labGlossary.marker.potassium.abbr': 'K+',
  'guide.labGlossary.marker.potassium.category': 'Electrolytes',
  'guide.labGlossary.marker.potassium.why': 'Potassium affects heart and muscle function. Abnormal values may occur with kidney/urinary disease, vomiting, diarrhea, or urinary blockage.',
  'guide.labGlossary.marker.potassium.typical': 'Dog/Cat commonly ~3.5–5.5 mmol/L.',
  'guide.labGlossary.marker.potassium.note': 'Urgent abnormalities can occur with blocked cats and severe dehydration.',
  'guide.labGlossary.marker.sodium.name': 'Sodium',
  'guide.labGlossary.marker.sodium.abbr': 'Na+',
  'guide.labGlossary.marker.sodium.category': 'Electrolytes',
  'guide.labGlossary.marker.sodium.why': 'Sodium reflects fluid balance and can shift with dehydration, endocrine disease, and kidney/urinary issues.',
  'guide.labGlossary.marker.sodium.typical': 'Dog/Cat commonly ~140–160 mmol/L.',
  'guide.labGlossary.marker.bicarbonate.name': 'Chloride',
  'guide.labGlossary.marker.bicarbonate.abbr': 'Cl−',
  'guide.labGlossary.marker.bicarbonate.category': 'Electrolytes',
  'guide.labGlossary.marker.bicarbonate.why': 'Chloride helps acid-base and hydration assessment, especially with sodium and bicarbonate.',
  'guide.labGlossary.marker.bicarbonate.typical': 'Dog/Cat commonly ~105–122 mmol/L.',
  'guide.labGlossary.marker.phosphate.name': 'Phosphorus',
  'guide.labGlossary.marker.phosphate.abbr': 'PHOS',
  'guide.labGlossary.marker.phosphate.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.phosphate.why': 'Phosphorus often rises as kidney disease progresses and is important for CKD staging and nutrition planning.',
  'guide.labGlossary.marker.phosphate.typical': 'Dog: ~2.5–6.0 mg/dL · Cat: ~2.5–6.8 mg/dL.',
  'guide.labGlossary.marker.calcium.name': 'Calcium',
  'guide.labGlossary.marker.calcium.abbr': 'Ca',
  'guide.labGlossary.marker.calcium.category': 'Electrolytes',
  'guide.labGlossary.marker.calcium.why': 'Calcium is important for nerves, muscle, and bones. Values may change with kidney disease, cancer, endocrine disorders, or low albumin.',
  'guide.labGlossary.marker.calcium.typical': 'Total calcium often ~8.5–11.8 mg/dL (species/lab dependent).',
  'guide.labGlossary.marker.haemoglobin.name': 'Red Cell Status',
  'guide.labGlossary.marker.haemoglobin.abbr': 'HGB / HCT / RBC',
  'guide.labGlossary.marker.haemoglobin.category': 'CBC',
  'guide.labGlossary.marker.haemoglobin.why': 'Red cell measurements assess anemia or dehydration. Chronic kidney disease can reduce red blood cell production.',
  'guide.labGlossary.marker.haemoglobin.typical': 'Ranges vary by species and analyzer; use your report\'s HGB/HCT/RBC intervals.',
  'guide.labGlossary.marker.wbc.name': 'White Blood Cell Count',
  'guide.labGlossary.marker.wbc.abbr': 'WBC',
  'guide.labGlossary.marker.wbc.category': 'CBC',
  'guide.labGlossary.marker.wbc.why': 'WBC helps assess inflammation, infection, stress response, and some bone marrow disorders.',
  'guide.labGlossary.marker.wbc.typical': 'Dog roughly ~6–17 ×10⁹/L · Cat ~5–19 ×10⁹/L.',
  'guide.labGlossary.marker.wbc.note': 'Look at differential counts (neutrophils/lymphocytes/eosinophils) for full interpretation.',
  'guide.labGlossary.marker.platelets.name': 'Platelets',
  'guide.labGlossary.marker.platelets.abbr': 'PLT',
  'guide.labGlossary.marker.platelets.category': 'CBC',
  'guide.labGlossary.marker.platelets.why': 'Platelets support blood clotting. Low platelets may increase bleeding risk; false lows can occur from platelet clumping.',
  'guide.labGlossary.marker.platelets.typical': 'Commonly ~200–500 ×10⁹/L (method dependent).',
  'guide.labGlossary.marker.altAst.name': 'ALT / AST',
  'guide.labGlossary.marker.altAst.abbr': 'ALT / AST',
  'guide.labGlossary.marker.altAst.category': 'Liver',
  'guide.labGlossary.marker.altAst.why': 'ALT/AST are liver-associated enzymes. Increases can reflect liver cell injury, inflammation, toxins, or muscle injury (especially AST).',
  'guide.labGlossary.marker.altAst.typical': 'Lab-specific; ALT is usually the more liver-specific value in dogs and cats.',
  'guide.labGlossary.marker.uricAcid.name': 'Albumin',
  'guide.labGlossary.marker.uricAcid.abbr': 'ALB',
  'guide.labGlossary.marker.uricAcid.category': 'Proteins & Other',
  'guide.labGlossary.marker.uricAcid.why': 'Albumin is a key blood protein that can drop with chronic inflammation, protein-losing kidney/gut disease, or liver dysfunction.',
  'guide.labGlossary.marker.uricAcid.typical': 'Dog: ~2.6–4.0 g/dL · Cat: ~2.5–3.9 g/dL.',
  'guide.labGlossary.marker.hba1c.name': 'Glucose',
  'guide.labGlossary.marker.hba1c.abbr': 'GLU',
  'guide.labGlossary.marker.hba1c.category': 'Metabolic',
  'guide.labGlossary.marker.hba1c.why': 'Glucose helps screen for diabetes and stress hyperglycemia (common in cats).',
  'guide.labGlossary.marker.hba1c.typical': 'Dog: ~70–120 mg/dL · Cat: ~70–150 mg/dL.',
  'guide.labGlossary.marker.cmv.name': 'Globulin',
  'guide.labGlossary.marker.cmv.abbr': 'GLOB',
  'guide.labGlossary.marker.cmv.category': 'Proteins & Other',
  'guide.labGlossary.marker.cmv.why': 'Globulins can increase with inflammation/infection and decrease with some immune or protein-losing disorders.',
  'guide.labGlossary.marker.cmv.typical': 'Dog: ~2.0–3.8 g/dL · Cat: ~2.8–5.1 g/dL.',
  'guide.labGlossary.marker.cmv.note': 'Interpret with albumin and total protein (A:G ratio is often useful).',
  'guide.labGlossary.marker.bkv.name': 'Bilirubin',
  'guide.labGlossary.marker.bkv.abbr': 'TBIL',
  'guide.labGlossary.marker.bkv.category': 'Liver',
  'guide.labGlossary.marker.bkv.why': 'Bilirubin can rise with liver disease, bile duct obstruction, or increased red blood cell breakdown.',
  'guide.labGlossary.marker.bkv.typical': 'Usually low/near-zero in healthy pets (lab dependent).',
  'guide.labGlossary.marker.upcr.name': 'Urine Protein:Creatinine Ratio',
  'guide.labGlossary.marker.upcr.abbr': 'UPC / UPCR',
  'guide.labGlossary.marker.upcr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.upcr.why': 'UPC estimates how much protein is lost in urine and helps monitor kidney disease progression and response to treatment.',
  'guide.labGlossary.marker.upcr.typical': 'Dog/Cat: <0.2 non-proteinuric, 0.2–0.5 borderline, >0.5 proteinuric (context matters).',
  'guide.labGlossary.marker.c0d.name': 'Urine Specific Gravity',
  'guide.labGlossary.marker.c0d.abbr': 'USG',
  'guide.labGlossary.marker.c0d.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.c0d.why': 'USG measures urine concentration and is essential for interpreting kidney values and hydration status.',
  'guide.labGlossary.marker.c0d.typical': 'Highly variable; persistently low USG with high kidney markers may indicate kidney dysfunction.',
  'guide.labGlossary.category.kidneyFunction': 'Kidney & Urinary',
  'guide.labGlossary.category.immunosuppressants': 'Chemistry',
  'guide.labGlossary.category.electrolytes': 'Electrolytes',
  'guide.labGlossary.category.bloodCount': 'CBC',
  'guide.labGlossary.category.liverFunction': 'Liver',
  'guide.labGlossary.category.metabolic': 'Metabolic',
  'guide.labGlossary.category.infections': 'Proteins & Other',
  // Register legal
  'register.byRegistering': 'Al registrarse, acepta nuestros',
  'register.and': 'y',
  'register.termsOfService': 'Términos de servicio',
  'register.privacyPolicy': 'Política de privacidad',
  // CSV headers
  'records.csv.date': 'Fecha',
  'records.csv.weight': 'Peso',
  'records.csv.fluidIn': 'Líquido ingerido',
  'records.csv.urineOut': 'Orina',
  'records.csv.amRegistered': 'Mañana Registrado',
  'records.csv.amBP': 'PA Mañana',
  'records.csv.amPulse': 'Pulso Mañana',
  'records.csv.amTemp': 'Temp. Mañana',
  'records.csv.pmRegistered': 'Tarde Registrado',
  'records.csv.pmBP': 'PA Tarde',
  'records.csv.pmPulse': 'Pulso Tarde',
  'records.csv.pmTemp': 'Temp. Tarde',
  'records.csv.observations': 'Observaciones',
  'records.csv.healthDiary': 'Diario de salud',
  // Roomies settings
  'options.roomies.description': 'Conéctese con pacientes post-trasplante de su grupo. Toda la actividad es anónima.',
  'options.roomies.nickname': 'Apodo',
  'options.roomies.nicknameMax': '(máx. 12 caracteres)',
  'options.roomies.nicknamePlaceholder': 'p. ej., Phoenix',
  'options.roomies.beanColour': 'Color del BEAN',
  'options.roomies.groupCode': 'Código de grupo',
  'options.roomies.groupCodePlaceholder': 'Ingrese o comparta su código de grupo',
  'options.roomies.groupCodeHint': 'Comparta este código con sus compañeros de hospital para que puedan unirse a su grupo.',
  'options.roomies.enableRoomies': 'Activar Roomies',
  'options.roomies.enableRoomiesHint': 'Permitir que su actividad aparezca en el feed del grupo',
  'options.roomies.noChanges': 'Sin cambios que guardar',
  'options.roomies.saveProfile': 'Guardar perfil Roomie',
  'options.roomies.saved': '¡Perfil Roomie guardado!',
  // Companionship (The Koda Fellowship)
  'companions.title': 'Compañerismo',
  'companions.pageTitle': 'La Hermandad Koda',
  'companions.subtitle': 'Mira cómo se compara tu mascota con otras en todo el mundo.',
  'companions.publicView': 'Vista pública',
  'companions.publicViewHint': 'Cuando está activada, tu mascota aparece en la clasificación global de La Hermandad Koda. Desactívala para mantenerte en privado — aún podrás ver a los demás.',
  'companions.publicViewOn': 'Visible en la clasificación',
  'companions.publicViewOff': 'Oculto en la clasificación',
  'companions.leaderboardTitle': 'Clasificación',
  'companions.leaderboardEmpty': 'Aún no hay companions — ¡sé el primero!',
  'companions.leaderboardHint': 'Ordenado por nivel y racha actual. Toca un emoji para animarles.',
  'companions.you': 'Tú',
  'companions.rank': 'Posición',
  'companions.score': 'Puntos',
  'companions.levelShort': 'Nv {n}',
  'companions.streakShort': 'Racha de {n} días',
  'companions.hiddenNotice': 'Estás oculto en la clasificación. Activa la Vista pública en Ajustes.',
  'companions.tabAll': 'Histórico',
  'companions.tabWeek': 'Esta semana',
  'companions.weekXPShort': '+{n} XP esta semana',
  'companions.leaderboardEmptyWeek': 'Aún no hay XP esta semana — ¡registra constantes para escalar!',
  'companions.leaderboardHintWeek': 'Ranking por XP ganado desde el lunes. Se reinicia cada semana.',
  'companions.story.title': 'Historia del compañero',
  'companions.story.modalTitle': 'Tu historia de compañero',
  'companions.story.hint': 'Elige una etiqueta y escribe una nota breve. Aparece debajo de tu fila en la clasificación.',
  'companions.story.placeholder': '¿Qué hay de nuevo con tu compañero?',
  'companions.story.save': 'Guardar historia',
  'companions.story.edit': 'Editar historia',
  'companions.story.clear': 'Quitar historia',
  'companions.story.expiresIn': 'Caduca en {n} d',
  'companions.story.recovered': 'Recuperado',
  'companions.story.vaccinated': 'Recién vacunado',
  'companions.story.grooming': 'Recién acicalado',
  'companions.story.vetVisit': 'Visita al vet',
  'companions.story.newTreat': 'Premio nuevo',
  'companions.story.birthday': '¡Cumpleaños!',
  'companions.story.feelingGreat': 'Genial',
  'companions.story.restingUp': 'Descansando',
  'companions.story.newHome': 'Hogar nuevo',
  // Bean page
  'bean.back': 'Volver',
  'bean.level': 'Nivel',
  'bean.yourBean': 'Tu BEAN',
  'bean.dailyStreak': 'Racha diaria',
  'bean.current': 'Actual',
  'bean.best': 'Mejor',
  'bean.totalXP': 'XP total',
  'bean.streakZero': '¡Registra tus signos vitales hoy para iniciar tu racha!',
  'bean.last30Days': 'Últimos 30 días',
  'bean.roomies': 'Compañerismo',
  'bean.active': 'Activo',
  'bean.connectText': 'Conéctate con otros dueños de mascotas en todo el mundo. Anímense mutuamente en la clasificación — de forma anónima.',
  'bean.setupRoomies': 'Activa la Vista pública en Ajustes → Compañerismo para aparecer en la clasificación.',
  'bean.roomiesSettings': 'Ajustes de Companion',
  'bean.preview': 'Vista previa',
  'bean.noActivity': 'Aún no hay companions — aparecerán aquí conforme registren.',
  'bean.keepGoing': '¡Sigue adelante!',
  'bean.justNow': 'ahora mismo',
  'bean.minsAgo': 'hace {n}min',
  'bean.hoursAgo': 'hace {n}h',
  'bean.daysAgo': 'hace {n}d',
  'bean.levelName.seedling': 'Semilla',
  'trial.endsToday': 'Tu prueba termina hoy — mejora ahora para conservar tus datos.',
  'trial.endsIn': 'La prueba termina en {days} día{s} — mejora para mantener el acceso.',
  'trial.upgrade': 'Mejorar',
  'trial.dismiss': 'Descartar',
  'layout.offlineBanner': 'Estás sin conexión — los cambios se sincronizarán cuando te reconectes',
  'layout.reconnectSyncing': 'De vuelta en línea — sincronizando {n} elemento(s) pendiente(s)…',
  'layout.reconnectSynced': 'Todos los cambios sincronizados ✓',
  'splash.preparing': 'Preparándolo todo para ti...',
  'bean.levelName.sprouting': 'Brotando',
  'bean.levelName.budding': 'Brote',
  'bean.levelName.rooted': 'Arraigado',
  'bean.levelName.thriving': 'Prosperando',
  'bean.levelName.flourishing': 'Floreciendo',
  'bean.levelName.resilient': 'Resiliente',
  'bean.levelName.champion': 'Campeón',
  'bean.levelName.guardian': 'Guardián',
  'bean.levelName.legend': 'Leyenda',
  'bean.feed.dailyLog': 'registró sus signos vitales hoy',
  'bean.feed.dailyLogStreak': 'registró sus signos vitales 🔥 racha de {n} días',
  'bean.feed.streakMilestone': 'alcanzó una racha de {n} días! 🎉',
  'bean.feed.guideArticle': 'leyó un artículo de la guía',
  'bean.feed.joinedGroup': 'se unió al grupo',
  'bean.feed.changedLook': 'actualizó su aspecto de BEAN 🎨',
  'bean.celebration.levelUpTitle': '¡Nivel {level}! 🎉',
  'bean.celebration.streakTitle': '¡Racha de {streak} días! 🔥',
  'bean.celebration.levelUpBody': 'Has alcanzado {name}. ¡Sigue así!',
  'bean.celebration.streakBody': '{streak} días seguidos — ¡consistencia increíble!',
  // Notifications
  'notifications.medReminder': 'Recordatorio de medicamento',
  'notifications.medReminderBody': 'Hora de tomar: {meds}',
  'notifications.dailyReminder': 'Recordatorio de registro diario',
  'notifications.dailyReminderBody': 'No ha registrado ningún dato hoy. Registrar sus signos vitales ayuda a hacer seguimiento de su salud.',
  'notifications.alarmTitle': '💊 Recordatorio de medicamento',
  'notifications.alarmBody': 'Hora de tomar {name} ({dosage})',
  // Guide / Library page
  'guide.articles': 'Artículos',
  'guide.subtitle': 'Guías, herramientas y registros de tu mascota.',
  'guide.resources': 'Recursos',
  'guide.minRead': 'min de lectura',
  'guide.unlocksInDay': 'Disponible en {n} día',
  'guide.unlocksInDays': 'Disponible en {n} días',
  'guide.category.contacts.title': 'Contactos Médicos',
  'guide.category.contacts.subtitle': 'Todo en un lugar seguro.',
  'guide.category.medical_card.title': 'Tarjeta Médica',
  'guide.category.medical_card.subtitle': 'Tu identificación médica.',
  'guide.category.emergency.title': 'Buscador de Veterinario de Emergencia',
  'guide.category.emergency.subtitle': 'Encuentra ahora la atención veterinaria más cercana.',
  'guide.category.how_to.title': 'Cómo: revisar signos vitales',
  'guide.category.how_to.subtitle': 'Guía paso a paso por tipo de animal.',
  'guide.category.hygiene.title': 'Higiene',
  'guide.category.hygiene.subtitle': 'La nueva normalidad: guía moderna de higiene pos-trasplante',
  'guide.category.exercise.title': 'Ejercicio',
  'guide.category.exercise.subtitle': 'El poder del movimiento: guía de ejercicio pos-trasplante',
  'guide.category.wellbeing.title': 'Bienestar',
  'guide.category.wellbeing.subtitle': 'Estado de ánimo, mentalidad y hábitos',
  'guide.category.food.title': 'Alimentación',
  'guide.category.food.subtitle': 'Comer bien después del trasplante',
  'guide.category.nutrition.title': 'Alimentación',
  'guide.category.nutrition.subtitle': 'Comer bien después del trasplante',
  'guide.category.sleep.title': 'Sueño',
  'guide.category.sleep.subtitle': 'Descanso y rutinas antes de dormir',
  'guide.category.lab_glossary.title': 'Glosario Lab',
  'guide.category.lab_glossary.subtitle': 'Entender tus resultados',
  'guide.category.vault.title': 'Archivos Médicos',
  'guide.category.vault.subtitle': 'Subir, guardar y acceder.',
  'guide.category.reminders.title': 'Recordatorios',
  'guide.category.reminders.subtitle': 'Alertas de medicación.',
  'guide.category.co-carers.title': 'Co-Carers',
  'guide.category.co-carers.subtitle': 'Share care with someone else.',
  // Auth — Register
  'register.disclaimerPrefix': 'Entiendo que KodaCare es una herramienta de seguimiento de salud, no un dispositivo médico, y acepto la',
  'register.passwordStrength': 'Seguridad:',
  'register.rule.minLength': 'Al menos 8 caracteres',
  'register.rule.uppercase': 'Letra mayúscula (A–Z)',
  'register.rule.lowercase': 'Letra minúscula (a–z)',
  'register.rule.number': 'Número (0–9)',
  'register.rule.special': 'Carácter especial (!@#$…)',
  'register.strength.veryWeak': 'Muy débil',
  'register.strength.weak': 'Débil',
  'register.strength.fair': 'Regular',
  'register.strength.strong': 'Fuerte',
  'register.strength.veryStrong': 'Muy fuerte',
  'register.error.emailInUse': 'Ya existe una cuenta con este correo electrónico.',
  'register.error.invalidEmail': 'Por favor, introduce una dirección de correo electrónico válida.',
  'register.error.weakPassword': 'Contraseña demasiado débil. Por favor, elige una más segura.',
  'register.error.network': 'Error de red. Comprueba tu conexión y vuelve a intentarlo.',
  'register.error.generic': 'Registro fallido. Por favor, inténtalo de nuevo.',
  'register.error.passwordRequirements': 'Por favor, cumple todos los requisitos de la contraseña.',
  'register.error.passwordsMustMatch': 'Las contraseñas no coinciden.',
  'register.error.googleFailed': 'Inicio de sesión de Google fallido. Por favor, inténtalo de nuevo.',
  // Auth — Login
  'login.error.incorrectCredentials': 'Correo electrónico o contraseña incorrectos.',
  'login.error.notVerified': 'Tu dirección de correo electrónico no ha sido verificada. Revisa tu bandeja de entrada.',
  'login.error.tooManyRequests': 'Demasiados intentos. Por favor, inténtalo de nuevo más tarde.',
  'login.error.network': 'Error de red. Comprueba tu conexión y vuelve a intentarlo.',
  'login.error.generic': 'Inicio de sesión fallido. Por favor, inténtalo de nuevo.',
  'login.error.googleFailed': 'Inicio de sesión de Google fallido. Por favor, inténtalo de nuevo.',
  // Medical Card
  'medcard.title': 'Tarjeta de Identificación Médica',
  'medcard.saveTitleAttr': 'Guardar en perfil',
  'medcard.saved': 'Guardado ✓',
  'medcard.saving': 'Guardando…',
  'medcard.save': 'Guardar',
  'medcard.shareAlt': 'Compartir como imagen',
  'medcard.shareFailed': 'Error al compartir',
  'medcard.hint': 'Toca cualquier campo para editar · Pulsa Guardar para sincronizar',
  'medcard.diary.title': 'Diario de salud',
  'medcard.diary.placeholder': 'Escribe todo sobre hoy: observaciones, disposición general, señales de buena y mala salud…',
  'medcard.diary.saved': 'Guardado',
  'medcard.diary.saving': 'Guardando…',
  'medcard.fullName': 'Nombre del Hooman',
  'medcard.profession': 'Nombre de la Mascota',
  'medcard.dob': 'Raza',
  'medcard.transplantDate': 'Fecha de Trasplante',
  'medcard.hospital': 'Hospital',
  'medcard.processNo': 'Nº de Proceso',
  'medcard.surgeon': 'Nefrólogo',
  'medcard.allergies': 'Alergias',
  'medcard.avgWeight': 'Peso Prom.',
  'medcard.medications': 'Medicamentos actuales',
  'medcard.avgBP': 'TA Prom.',
  'medcard.placeholder.name': 'Toca para introducir el nombre',
  'medcard.placeholder.profession': 'Toca para introducir',
  'medcard.placeholder.dob': 'ej. Británico de pelo corto',
  'medcard.placeholder.hospital': 'Nombre del hospital',
  'medcard.placeholder.processNo': 'ej. 123456',
  'medcard.placeholder.surgeon': 'Nombre del nefrólogo',
  'medcard.placeholder.allergies': 'Ninguna conocida',
  // Records — Today's Card
  'records.todaysCard': 'Tarjeta de Hoy',
  'records.todaysCardComplete': '¡Tarjeta de hoy completa!',
  'records.allThreeLogged': 'Los tres pasos registrados — ¡excelente trabajo hoy!',
  'records.filesTooLarge': 'Se omitió/omitieron {n} archivo(s) de más de {mb}MB.',
  'records.stepLocked': 'Bloqueado',
  // Trends
  'trends.showLast': 'Mostrar los últimos:',
  // Guide wrappers
  'guide.renderError': 'Error al renderizar el contenido:',
  // AppointmentCalendar
  'appt.kind.checkup': 'Chequeo',
  'appt.kind.lab': 'Laboratorio',
  'appt.kind.medication': 'Medicación',
  'appt.kind.other': 'Otro',
  'appt.noAppointments': 'Sin citas este día',
  'appt.upcoming': 'Próximos',
  'appt.today': 'Hoy',
  'appt.addEvent': 'Añadir evento',
  'appt.editEvent': 'Editar evento',
  'appt.titleLabel': 'Título',
  'appt.titlePlaceholder': 'p. ej. Refuerzo de vacuna',
  'appt.dateLabel': 'Fecha',
  'appt.timeLabel': 'Hora',
  'appt.kindLabel': 'Tipo',
  'appt.doctorLabel': 'Veterinario',
  'appt.doctorPlaceholder': 'Opcional',
  'appt.locationLabel': 'Lugar',
  'appt.locationPlaceholder': 'Opcional',
  'appt.save': 'Guardar',
  'appt.cancel': 'Cancelar',
  'appt.delete': 'Eliminar',
  'appt.deleteConfirm': '¿Eliminar este evento?',
  // Records share
  'records.weekOf': 'Semana del',
  'records.share.title': 'Resumen diario KodaCare',
  'records.share.weight': 'Peso:',
  'records.share.morning': 'Mañana:',
  'records.share.afternoon': 'Tarde:',
  'records.share.fluidInOut': 'Líquido ingerido: {fluidIn}  |  Orina: {fluidOut}',
  'records.share.note': 'Nota:',
  'records.share.dataTitle': 'Datos de salud KodaCare',
  'records.share.dataText': 'Mis datos de salud de KodaCare - {date}',
  // Notifications accessibility
  'notifications.dismiss': 'Descartar',
  'notifications.bellLabel': 'Notificaciones',
  'notifications.settingsLabel': 'Configuración de notificaciones',
  'notifications.fallbackTitle': 'Recordatorio KodaCare',
  'fab.voiceHint': 'Cuando esté listo, diga "Iniciar temporizador Koda"',
  'fab.voicePhrase': 'iniciar temporizador koda',
  'notifications.fallbackBody': 'Tienes un nuevo recordatorio.',
  // Vitals redesign stubs
  'records.heartRate': 'Heart Rate',
  'records.respRate': 'Respiratory Rate',
  'records.heartRateRecorded': 'Heart Rate Recorded',
  'records.respRateRecorded': 'Respiratory Rate Recorded',
  'records.temperatureRecorded': 'Temperature Recorded',
  'records.undoHeartRate': 'Undo heart rate',
  'records.undoRespRate': 'Undo respiratory rate',
  'records.undoTemperature': 'Undo temperature',
  'records.wellnessCheck': 'Wellness',
  'records.mucousMembranes': 'Mucous Membranes',
  'records.mm.pink': 'Pink',
  'records.mm.red': 'Red',
  'records.mm.blue': 'Blue',
  'records.mm.white': 'White',
  'records.csv.heartRate': 'Heart Rate (bpm)',
  'records.csv.respRate': 'Resp. Rate (bpm)',
  'records.csv.mucousMembrane': 'Mucous Membrane',
  'records.csv.temp': 'Temp',
  'records.share.fluidIn': 'Fluid In',
  'records.countFor15s': 'Count beats for 15 seconds',
  'records.countBreathsFor15s': 'Count breaths for 15 seconds',
  'records.beats': 'beats',
  'records.breaths': 'breaths',
  'records.saveHeartRate': 'Save Heart Rate',
  'records.saveRespRate': 'Save Respiratory Rate',
  'records.temperature': 'Temperature',
  'records.saveTemperature': 'Save Temperature',
  // Onboarding walkthrough
  'walkthrough.polyName': 'Koda',
  'walkthrough.skip': 'Omitir',
  'walkthrough.back': 'Atrás',
  'walkthrough.letsGo': 'Vamos',
  'walkthrough.next': 'Siguiente',
  'walkthrough.finish': '¡Listo! 🎉',
  'walkthrough.step0.title': '¡Hola, soy Koda!',
  'walkthrough.step0.body': '¡Un placer conocerte! He preparado un regalo de bienvenida de +30 XP para ti. Más sobre eso luego… Te mostraré todo.',
  'walkthrough.step1.title': 'Control diario',
  'walkthrough.step1.body': 'Registra los signos vitales de tu mascota aquí tan a menudo como sea posible — cada día es perfecto.',
  'walkthrough.step2.title': 'Tendencias de salud',
  'walkthrough.step2.body': 'Observa cómo evoluciona la salud de tu mascota con estos gráficos.',
  'walkthrough.step3.title': 'Medicamentos',
  'walkthrough.step3.body': 'Sigue los medicamentos, horarios y dosis — nunca te pierdas una dosis con recordatorios directamente en tu dispositivo.',
  'walkthrough.step4.title': 'Tu biblioteca de cuidados',
  'walkthrough.step4.body': 'Todo en un lugar — guías para ganar XP, la tarjeta de tu mascota, contactos del equipo de cuidados, registros veterinarios y más. Toca cualquier recurso para empezar.',
  'walkthrough.step5.title': 'Tu progreso',
  'walkthrough.step5.body': 'Sigue tus rachas y progreso de XP, y conoce a otros cuidadores en las tablas de Compañerismo.',
  'options.replayWalkthrough': 'Repetir introducción',
  'members.title': 'Co-cuidadores',
  'members.membersTitle': 'Miembros actuales',
  'members.inviteTitle': 'Invitar a un co-cuidador',
  'members.inviteHint': 'Crea un enlace de invitación seguro y compártelo directamente por iMessage, WhatsApp o cualquier app de mensajes.',
  'members.createLink': 'Crear enlace de invitación',
  'members.copyLink': 'Copiar enlace',
  'members.copied': '¡Copiado!',
  'members.linkCopied': 'Enlace copiado — compártelo con tu co-cuidador.',
  'members.inviteError': 'No se pudo crear el enlace de invitación. Inténtalo de nuevo.',
  'members.pendingTitle': 'Invitaciones pendientes',
  'members.cancelInvite': 'Cancelar',
  'members.owner': 'Propietario',
  'members.remove': 'Eliminar acceso',
  'members.confirmRemove': '¿Eliminar a {name} como co-cuidador?',
  'members.joinedOn': 'Se unió el',
  'members.sentOn': 'Enviado el',
  'members.loading': 'Cargando…',
  'members.noMembers': 'Aún no hay miembros.',
  'members.viewOnlyNotice': 'Eres co-cuidador de esta mascota. Solo el propietario puede gestionar el acceso.',
  'members.coCarers': 'Co-cuidadores',
  'members.coCarersSubtitle': 'Compartir el cuidado de esta mascota con otra persona',
  'members.transferTitle': 'Transferir propiedad',
  'members.transferHint': 'Transfiere la propiedad completa del perfil de {petName} a otro usuario de KodaCare. El destinatario debe tener una suscripción activa. Permanecerás como co-cuidador tras la transferencia.',
  'members.transferWarning': 'Esta acción es permanente e irreversible. Perderás los privilegios de propietario de esta mascota.',
  'members.transferEmail': 'Correo electrónico del destinatario',
  'members.transferSelectCarer': 'Selecciona un co-cuidador existente:',
  'members.transferAction': 'Transferir',
  'members.transferConfirm': '¿Transferir la propiedad de {petName} a {email}? Esta acción no se puede deshacer.',
  'members.transferSuccess': 'Propiedad transferida. Ahora eres co-cuidador de esta mascota.',
  'members.transferError': 'No se pudo transferir la propiedad. Inténtalo de nuevo.',
  'coCarer.removedNotice.title': 'Has sido eliminado',
  'coCarer.removedNotice.body': 'El propietario te ha eliminado como cocuidador de {petName}. El perfil y los datos de esta mascota ya no aparecerán en tu cuenta.',
  'coCarer.removedNotice.ok': 'OK',
  'doses.markAsGiven': 'Marcar como administrado',
  'doses.givenBy': 'Administrado por',
  'doses.at': 'a las',
  'doses.alreadyGiven': 'Ya administrado',
};